(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-album"] && !Shopify.designMode) return;
  try {
    
  const mfAlReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mfAlFmt = (n) => Math.round(n).toLocaleString('en-US');
  const mfAlRarity = (type) => {
    if (/icon/.test(type)) return 'i';
    if (/hall_of_fut|totw/.test(type)) return 't';
    if (/evo|squad|partners/.test(type)) return 'e';
    if (/future|hero/.test(type)) return 'c';
    if (/potm/.test(type)) return 'p';
    if (type === 'rare_gold') return 'g';
    return 'v';
  };

  class MfAlInview extends HTMLElement {
    connectedCallback() {
      this.io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.classList.add('is-in');
          this.io.disconnect();
        },
        { threshold: 0.35 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }
  }

  class MfAlbum extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      try {
        this.cfg = JSON.parse(this.querySelector('[data-config]').textContent);
      } catch {
        this.cfg = {};
      }
      this.refs = {};
      this.querySelectorAll('[data-ref]').forEach((el) => (this.refs[el.dataset.ref] = el));
      this.observers = [];
      this.total = Number((this.refs.total?.textContent || '').replace(/\D/g, '')) || 0;
      this.ready = this.load().then((data) => {
        if (data) this.render(data);
        return data;
      });

      this.watch(this.querySelector('.mf-al-book'), (el) => this.fillBook(el), 0.3);
      this.querySelectorAll('[data-count]').forEach((el) => this.watch(el, () => this.ready.then(() => this.count(el)), 0.6));
      this.startClock();
    }

    disconnectedCallback() {
      this.observers.forEach((o) => o.disconnect());
      clearInterval(this.clockTimer);
    }

    watch(el, fn, threshold) {
      if (!el) return;
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          io.disconnect();
          fn(el);
        },
        { threshold }
      );
      io.observe(el);
      this.observers.push(io);
    }

    async fetchJson(url) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 6000);
      try {
        const res = await fetch(url, { signal: controller.signal, credentials: 'omit' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (!Array.isArray(data.cards) || !Array.isArray(data.collections)) throw new Error('bad feed');
        return data;
      } finally {
        clearTimeout(timer);
      }
    }

    async load() {
      const sources = [this.cfg.feed, this.cfg.fallback].filter(Boolean);
      for (const url of sources) {
        try {
          return await this.fetchJson(url);
        } catch {
          /* try the next source */
        }
      }
      return null;
    }

    set(ref, value) {
      const el = this.refs[ref];
      if (!el) return;
      if (el.hasAttribute('data-count')) el.dataset.to = String(value);
      el.textContent = mfAlFmt(value);
    }

    render(data) {
      const groups = new Map(data.collections.map((c) => [c.key, c]));
      const specials = data.collections.filter((c) => c.kind === 'special');
      const tier = (k) => groups.get(k)?.count || 0;
      const special = specials.reduce((s, c) => s + (c.count || 0), 0);
      const total = tier('bronze') + tier('silver') + tier('gold') + special;
      if (total < 1000) return;

      this.total = total;
      const hours = Math.floor(total / 60);
      this.set('bronze', tier('bronze'));
      this.set('silver', tier('silver'));
      this.set('gold', tier('gold'));
      this.set('special', special);
      this.set('total', total);
      this.set('total2', total);
      this.set('hours', hours);
      this.set('hours2', hours);
      this.set('days', Math.floor(hours / 24));
      if (this.refs.specialSets && specials.length) this.refs.specialSets.textContent = String(specials.length);
      if (this.refs.bookTotal) this.refs.bookTotal.textContent = mfAlFmt(total);

      const types = data.types || {};
      const best = new Map();
      data.cards.forEach((row) => {
        const [, , rating, , type] = row;
        if (!best.has(type) || best.get(type) < rating) best.set(type, rating);
      });
      const picks = [...best.entries()].sort((a, b) => b[1] - a[1]).slice(0, 5);
      this.querySelectorAll('[data-ut]').forEach((card, i) => {
        const pick = picks[i];
        if (!pick) return;
        card.className = `mf-al-mc mf-al-mc--${mfAlRarity(pick[0])}`;
        card.querySelector('b').textContent = String(pick[1]);
        card.querySelector('small').textContent = types[pick[0]] || 'Untradeable';
      });
    }

    count(el) {
      const to = Number(el.dataset.to || el.textContent.replace(/\D/g, '')) || 0;
      if (!to || mfAlReduced()) {
        el.textContent = mfAlFmt(to);
        return;
      }
      const start = performance.now();
      const dur = 1500;
      const step = (now) => {
        const t = Math.min(1, (now - start) / dur);
        el.textContent = mfAlFmt(to * (1 - Math.pow(1 - t, 3)));
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    fillBook(book) {
      const done = () => {
        if (this.refs.bookCount) this.refs.bookCount.textContent = mfAlFmt(this.total);
        if (this.refs.bookBar) this.refs.bookBar.style.transform = 'scaleX(1)';
        book.classList.add('is-filling', 'is-complete');
      };
      Promise.race([this.ready, new Promise((r) => setTimeout(r, 1500))]).then(() => {
        if (mfAlReduced()) return done();
        book.classList.add('is-filling');
        const start = performance.now();
        const dur = 2600;
        const step = (now) => {
          const t = Math.min(1, (now - start) / dur);
          const p = 1 - Math.pow(1 - t, 2.2);
          if (this.refs.bookCount) this.refs.bookCount.textContent = mfAlFmt(this.total * p);
          if (this.refs.bookBar) this.refs.bookBar.style.transform = `scaleX(${p})`;
          if (t < 1) requestAnimationFrame(step);
          else done();
        };
        requestAnimationFrame(step);
      });
    }

    startClock() {
      const el = this.querySelector('[data-clock]');
      if (!el) return;
      const tick = () => {
        el.textContent = new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      };
      tick();
      this.clockTimer = setInterval(tick, 30000);
    }
  }

  class MfAlGift extends HTMLElement {
    connectedCallback() {
      this.pack = this.querySelector('.mf-al-pack');
      this.reveal = this.querySelector('.mf-al-gift__reveal');
      if (!this.pack || !this.reveal) return;
      this.onClick = () => this.open();
      this.pack.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.pack?.removeEventListener('click', this.onClick);
      clearTimeout(this.timer);
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      this.pack.setAttribute('aria-expanded', 'true');
      this.timer = setTimeout(
        () => {
          this.pack.hidden = true;
          this.reveal.hidden = false;
          this.classList.add('is-revealed');
          this.reveal.setAttribute('tabindex', '-1');
          this.reveal.focus({ preventScroll: true });
        },
        mfAlReduced() ? 0 : 1300
      );
    }
  }

  if (!customElements.get('mf-al-inview')) customElements.define('mf-al-inview', MfAlInview);
  if (!customElements.get('mf-al-gift')) customElements.define('mf-al-gift', MfAlGift);
  if (!customElements.get('mf-album')) customElements.define('mf-album', MfAlbum);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-autotap"] && !Shopify.designMode) return;
  try {
    
  const mfAtReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class MfAtLive extends HTMLElement {
    connectedCallback() {
      this.ticks = [...this.querySelectorAll('[data-tick]')].map((el) => ({
        el,
        ms: Number(el.dataset.tick),
        n: Number(el.dataset.start || el.textContent.replace(/\D/g, '') || 0),
      }));
      this.timers = [];
      this.io = new IntersectionObserver((entries) => {
        this.live = entries.some((e) => e.isIntersecting);
        this.classList.toggle('is-live', this.live);
        this.sync();
      });
      this.io.observe(this);
      this.onVis = () => this.sync();
      document.addEventListener('visibilitychange', this.onVis);
    }

    disconnectedCallback() {
      this.io?.disconnect();
      document.removeEventListener('visibilitychange', this.onVis);
      this.stop();
    }

    stop() {
      this.timers.forEach(clearInterval);
      this.timers = [];
    }

    sync() {
      const run = this.live && !document.hidden && !mfAtReduced();
      if (run && !this.timers.length) {
        this.timers = this.ticks.map((t) =>
          setInterval(() => {
            t.n += 1;
            t.el.textContent = t.n.toLocaleString('en-US');
          }, t.ms)
        );
      }
      if (!run) this.stop();
    }
  }

  class MfAtOnce extends HTMLElement {
    connectedCallback() {
      this.io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.classList.add('is-in');
          this.io.disconnect();
        },
        { threshold: 0.45 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }
  }

  class MfAtGift extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('.mf-at-ticket');
      if (!this.box) return;
      this.reveal = this.querySelector('.mf-at-gift__reveal');
      this.onClick = () => this.open();
      this.box.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.box?.removeEventListener('click', this.onClick);
      clearTimeout(this.timer);
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      this.box.setAttribute('aria-expanded', 'true');
      this.timer = setTimeout(
        () => {
          this.box.disabled = true;
          this.reveal.hidden = false;
          this.classList.add('is-revealed');
          this.reveal.setAttribute('tabindex', '-1');
          this.reveal.focus({ preventScroll: true });
        },
        mfAtReduced() ? 0 : 800
      );
    }
  }

  if (!customElements.get('mf-at-gift')) customElements.define('mf-at-gift', MfAtGift);
  if (!customElements.get('mf-at-live')) customElements.define('mf-at-live', MfAtLive);
  if (!customElements.get('mf-at-once')) customElements.define('mf-at-once', MfAtOnce);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-bot-trades"] && !Shopify.designMode) return;
  try {
    
  function mfBtWatch(el, onEnter, onLeave) {
    const io = new IntersectionObserver(
      ([entry]) => (entry.isIntersecting ? onEnter() : onLeave?.()),
      { rootMargin: '-30% 0px -30% 0px', threshold: 0 }
    );
    io.observe(el);
    return io;
  }

  class MfBtPlay extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-at]')];
      this.lit = [...this.querySelectorAll('[data-from]')];
      this.bars = [...this.querySelectorAll('[data-bar]')];
      this.phases = [...this.querySelectorAll('[data-phase]')];
      this.replay = this.querySelector('[data-replay]');
      try {
        this.delays = JSON.parse(this.dataset.delays);
      } catch {
        this.delays = [];
      }
      this.last = this.delays.length;
      this.step = 0;
      this.timer = null;
      this.dataset.ready = '';

      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return this.render(this.last);

      this.render(0);
      this.replay?.addEventListener('click', (this.onReplay = () => this.restart()));
      this.io = mfBtWatch(
        this.querySelector('.mf-bt-part__screen') || this,
        () => this.resume(),
        () => this.pause()
      );
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.io?.disconnect();
      this.replay?.removeEventListener('click', this.onReplay);
    }

    resume() {
      if (this.timer != null || this.step >= this.last) return;
      this.timer = setTimeout(() => this.tick(), this.step === 0 ? 500 : 700);
    }

    pause() {
      clearTimeout(this.timer);
      this.timer = null;
    }

    restart() {
      this.pause();
      this.step = 0;
      this.render(0);
      this.resume();
    }

    tick() {
      this.step += 1;
      this.render(this.step);
      if (this.step >= this.last) {
        this.timer = null;
        if (this.replay) this.replay.hidden = false;
        return;
      }
      this.timer = setTimeout(() => this.tick(), this.delays[this.step] || 1200);
    }

    render(step) {
      if (this.replay && step < this.last) this.replay.hidden = true;
      for (const el of this.items) {
        const at = Number(el.dataset.at);
        const until = el.dataset.until == null ? Infinity : Number(el.dataset.until);
        el.classList.toggle('is-on', step >= at && step <= until);
      }
      for (const el of this.lit) el.classList.toggle('is-lit', step >= Number(el.dataset.from));
      for (const el of this.bars) {
        let values = [];
        try {
          values = JSON.parse(el.dataset.bar);
        } catch {}
        el.style.setProperty('--p', String(values[Math.min(step, values.length - 1)] ?? 1));
      }
      let active = null;
      for (const el of this.phases) if (step >= Number(el.dataset.phase)) active = el;
      for (const el of this.phases) el.classList.toggle('is-active', el === active);
    }
  }

  class MfBtTilt extends HTMLElement {
    connectedCallback() {
      if (!matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) return;
      this.onMove = (e) => {
        const r = this.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        this.style.setProperty('--ry', `${(x * 14).toFixed(2)}deg`);
        this.style.setProperty('--rx', `${(-y * 10).toFixed(2)}deg`);
        this.style.setProperty('--gx', `${((x + 0.5) * 100).toFixed(1)}%`);
      };
      this.onLeave = () => {
        this.style.removeProperty('--ry');
        this.style.removeProperty('--rx');
        this.style.removeProperty('--gx');
      };
      this.addEventListener('pointermove', this.onMove);
      this.addEventListener('pointerleave', this.onLeave);
    }

    disconnectedCallback() {
      this.removeEventListener('pointermove', this.onMove);
      this.removeEventListener('pointerleave', this.onLeave);
    }
  }

  class MfBtWish extends HTMLElement {
    static TIERS = ['gold', 'violet', 'cyan', 'green'];
    static PAGES = [
      [['98', 'ST'], ['96', 'CAM'], ['95', 'CB']],
      [['97', 'LW'], ['95', 'CM'], ['94', 'GK']],
      [['99', 'CF'], ['96', 'RW'], ['93', 'CDM']],
      [['97', 'RB'], ['98', 'CAM'], ['95', 'ST']],
    ];

    connectedCallback() {
      this.cards = [...this.querySelectorAll('.mf-bt-wish__card')];
      this.btn = this.querySelector('.mf-bt-wish__btn');
      this.page = this.querySelector('.mf-bt-wish__page b');
      this.n = 0;
      this.btn?.addEventListener('click', (this.onClick = () => this.next()));
    }

    disconnectedCallback() {
      this.btn?.removeEventListener('click', this.onClick);
      clearTimeout(this.timer);
    }

    next() {
      if (this.busy) return;
      this.busy = true;
      this.classList.add('is-out');
      const swap = () => {
        this.n += 1;
        const tier = MfBtWish.TIERS[this.n % MfBtWish.TIERS.length];
        const cards = MfBtWish.PAGES[this.n % MfBtWish.PAGES.length];
        this.cards.forEach((card, i) => {
          for (const t of MfBtWish.TIERS) card.classList.remove(`mf-bt-card--${t}`);
          card.classList.add(`mf-bt-card--${tier}`);
          card.querySelector('b').textContent = cards[i][0];
          card.querySelector('small').textContent = cards[i][1];
        });
        if (this.page) this.page.textContent = String(this.n + 1);
        this.classList.remove('is-out');
        this.busy = false;
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return swap();
      this.timer = setTimeout(swap, 320);
    }
  }

  class MfBtInview extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('.mf-bt-race__lane--us li')];
      this.counter = this.querySelector('[data-count]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reduced) {
        this.classList.add('is-in');
        this.style.setProperty('--s', String(this.steps.length || 1));
        this.steps.forEach((li) => li.classList.add('is-done'));
        this.classList.add('is-finished');
        return;
      }
      this.io = mfBtWatch(this, () => this.enter(), () => this.leave());
    }

    disconnectedCallback() {
      this.io?.disconnect();
      clearInterval(this.interval);
      cancelAnimationFrame(this.raf);
    }

    enter() {
      this.classList.add('is-in');
      if (this.steps.length && !this.raced) this.race();
      if (this.counter && !this.counting) this.count();
    }

    leave() {
      if (this.counter && !this.counting) this.counted = false;
    }

    race() {
      this.raced = true;
      let n = 0;
      const total = this.steps.length;
      const advance = () => {
        n += 1;
        this.style.setProperty('--s', String(n));
        this.steps.forEach((li, i) => li.classList.toggle('is-done', i < n));
        if (n >= total) {
          clearInterval(this.interval);
          this.classList.add('is-finished');
        }
      };
      advance();
      this.interval = setInterval(advance, 1000);
    }

    count() {
      if (this.counted) return;
      this.counted = true;
      this.counting = true;
      const el = this.counter;
      const target = Number(el.dataset.count) || 0;
      el.classList.remove('is-pop');
      el.textContent = '0';
      const start = performance.now() + 250;
      const step = (now) => {
        const t = Math.max(0, Math.min(1, (now - start) / 1600));
        el.textContent = String(Math.round(target * (1 - Math.pow(1 - t, 3))));
        if (t < 1) {
          this.raf = requestAnimationFrame(step);
        } else {
          this.counting = false;
          el.classList.add('is-pop');
        }
      };
      this.raf = requestAnimationFrame(step);
    }
  }

  class MfBtGift extends HTMLElement {
    connectedCallback() {
      this.dataset.ready = '';
      this.btn = this.querySelector('.mf-bt-gift__open');
      this.btn?.addEventListener('click', (this.onOpen = () => this.open()));
    }

    disconnectedCallback() {
      this.btn?.removeEventListener('click', this.onOpen);
      clearTimeout(this.timer);
    }

    open() {
      if (this.hasAttribute('data-open')) return;
      this.btn.setAttribute('aria-expanded', 'true');
      this.dataset.open = '';
      const done = () => {
        this.dataset.revealed = '';
        this.querySelector('.mf-bt-vip__claim')?.focus({ preventScroll: true });
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return done();
      this.timer = setTimeout(done, 900);
    }
  }

  class MfBtLevel extends HTMLElement {
    connectedCallback() {
      this.refs = {};
      this.querySelectorAll('[data-ref]').forEach((el) => (this.refs[el.dataset.ref] = el));
      this.ring = this.querySelector('.mf-bt-level__ring');
      this.refs.range?.addEventListener('input', (this.onInput = () => this.update()));
      this.update();
    }

    disconnectedCallback() {
      this.refs.range?.removeEventListener('input', this.onInput);
    }

    update() {
      const lvl = Number(this.refs.range?.value || 1);
      const progress = Math.min(1, lvl / 25);
      const ok = lvl >= 25;
      this.classList.toggle('is-unlocked', ok);
      this.style.setProperty('--h', String(Math.round(progress * 130)));
      this.ring?.style.setProperty('--lv', String(progress));
      if (this.refs.lvl) this.refs.lvl.textContent = String(lvl);
      if (this.refs.state) {
        const left = 25 - lvl;
        this.refs.state.textContent = ok
          ? 'Trading unlocked. You are ready to go.'
          : `${left} level${left === 1 ? '' : 's'} until Trading unlocks`;
      }
    }
  }

  class MfBtCalc extends HTMLElement {
    connectedCallback() {
      this.refs = {};
      this.querySelectorAll('[data-ref]').forEach((el) => (this.refs[el.dataset.ref] = el));
      try {
        this.packs = JSON.parse(this.refs.packs.textContent).sort((a, b) => a.n - b.n);
      } catch {
        this.packs = [];
      }
      this.unl = Number(this.dataset.unlimited);
      if (!this.packs.length || !this.refs.range) return;
      this.fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        currencyDisplay: 'narrowSymbol',
      });
      this.breakEven = this.findBreakEven();
      this.refs.range.addEventListener('input', (this.onInput = () => this.update()));
      this.update();
    }

    disconnectedCallback() {
      this.refs.range?.removeEventListener('input', this.onInput);
    }

    table() {
      if (this.cost) return;
      const max = 5000 + this.packs[this.packs.length - 1].n;
      this.cost = new Array(max + 1).fill(Infinity);
      this.pick = new Array(max + 1).fill(-1);
      this.cost[0] = 0;
      for (let t = 1; t <= max; t++) {
        this.packs.forEach((p, i) => {
          if (p.n <= t && this.cost[t - p.n] + p.p < this.cost[t]) {
            this.cost[t] = this.cost[t - p.n] + p.p;
            this.pick[t] = i;
          }
        });
      }
    }

    cheapest(target) {
      this.table();
      const max = target + this.packs[this.packs.length - 1].n;
      let best = target;
      for (let t = target; t <= max; t++) if (this.cost[t] < this.cost[best]) best = t;
      const mix = {};
      for (let t = best; t > 0 && this.pick[t] >= 0; t -= this.packs[this.pick[t]].n) {
        const n = this.packs[this.pick[t]].n;
        mix[n] = (mix[n] || 0) + 1;
      }
      return { cost: this.cost[best], mix };
    }

    findBreakEven() {
      for (let n = 10; n <= 5000; n += 10) if (this.cheapest(n).cost >= this.unl) return n;
      return null;
    }

    money(cents) {
      return this.fmt.format(cents / 100);
    }

    update() {
      const n = Number(this.refs.range.value);
      const { cost, mix } = this.cheapest(n);
      this.refs.n.value = String(n);
      this.refs['packs-total'].textContent = this.money(cost);
      this.refs['packs-mix'].textContent = Object.keys(mix)
        .sort((a, b) => b - a)
        .map((k) => `${mix[k]} × ${k} trades`)
        .join(' + ');
      const v = this.refs.verdict;
      if (cost >= this.unl) {
        v.textContent = `Unlimited saves you ${this.money(cost - this.unl)}, and every trade after that is free.`;
        this.classList.add('is-win');
      } else {
        v.textContent = this.breakEven
          ? `Unlimited pays for itself at about ${this.breakEven} trades. Everything after that is free.`
          : 'Buying trades is the better fit for now.';
        this.classList.remove('is-win');
      }
    }
  }

  function mfBtAmounts(root) {
    for (const form of root.querySelectorAll('.mf-bt-amounts')) {
      if (form.dataset.bound) continue;
      form.dataset.bound = '';
      const summary = form.querySelector('[data-ref="summary"]');
      const label = form.querySelector('[data-ref="buy-label"]');
      const sync = () => {
        const r = form.querySelector('input[name="id"]:checked');
        if (!r) return;
        if (label) label.textContent = `Buy ${r.dataset.trades} trades`;
        if (summary) summary.textContent = `${r.dataset.trades} trades · ${Number(r.dataset.trades) * 3} cards · ${r.dataset.price}`;
      };
      form.addEventListener('change', sync);
      sync();
    }
  }

  if (!customElements.get('mf-bt-play')) customElements.define('mf-bt-play', MfBtPlay);
  if (!customElements.get('mf-bt-tilt')) customElements.define('mf-bt-tilt', MfBtTilt);
  if (!customElements.get('mf-bt-wish')) customElements.define('mf-bt-wish', MfBtWish);
  if (!customElements.get('mf-bt-inview')) customElements.define('mf-bt-inview', MfBtInview);
  if (!customElements.get('mf-bt-calc')) customElements.define('mf-bt-calc', MfBtCalc);
  if (!customElements.get('mf-bt-gift')) customElements.define('mf-bt-gift', MfBtGift);
  if (!customElements.get('mf-bt-level')) customElements.define('mf-bt-level', MfBtLevel);
  mfBtAmounts(document);
  document.addEventListener('shopify:section:load', (e) => mfBtAmounts(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-cards')) {
    const TIERS = ['bronze', 'silver', 'gold'];
    const BUNDLE = 'tiers';
    const SPECIAL = 'special:';
    const PAGE = 24;
    const SPECIALS_SHOWN = 10;
    const SPECIALS_FOLDED = 8;
    const STORE_KEY = 'mf-cards-selection';
    const POSITIONS = {
      att: ['ST', 'CF', 'LW', 'RW', 'LF', 'RF'],
      mid: ['CAM', 'CM', 'CDM', 'LM', 'RM'],
      def: ['CB', 'LB', 'RB', 'LWB', 'RWB'],
      gk: ['GK'],
    };

    const esc = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);

    const TIER_RARITY = /^(?:rare_)?(bronze|silver|gold)$/;

    customElements.define(
      'mf-cards',
      class extends HTMLElement {
        connectedCallback() {
          this.cfg = JSON.parse(this.querySelector('[data-config]').textContent);
          this.ladder = this.cfg.ladder
            .map((step) => step.split(':').map(Number))
            .filter(([qty, pct]) => qty > 0 && pct > 0)
            .sort((a, b) => a[0] - b[0]);
          this.money = new Intl.NumberFormat(this.cfg.locale || undefined, { style: 'currency', currency: this.cfg.currency || 'GBP' });
          this.filters = { q: '', type: '', pos: '', league: '', sort: 'rating' };
          this.page = matchMedia('(max-width: 749px)').matches ? 12 : PAGE;
          this.limit = this.page;
          this.specialsOpen = false;
          this.sel = { cards: [], cols: [], extras: [] };
          this.el = (selector) => this.querySelector(selector);

          this.addEventListener('click', (event) => this.onClick(event));
          this.addEventListener('input', (event) => this.onFilter(event));
          this.addEventListener('change', (event) => this.onFilter(event));
          this.addEventListener(
            'error',
            (event) => {
              const img = event.target;
              if (img.tagName !== 'IMG') return;
              img.closest('.mf-card27__art')?.classList.add('is-missing');
              img.remove();
            },
            true
          );
          this.load();
        }

        offer(key) {
          const offer = this.cfg.offers[key];
          return offer && offer.available ? offer : null;
        }

        async fetchJson(url, ms) {
          const controller = new AbortController();
          const timer = setTimeout(() => controller.abort(), ms);
          try {
            const res = await fetch(url, { signal: controller.signal, credentials: 'omit' });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            if (!Array.isArray(data.cards) || !Array.isArray(data.collections)) throw new Error('bad feed');
            return data;
          } finally {
            clearTimeout(timer);
          }
        }

        async load() {
          let data = null;
          for (const [url, ms] of [[this.cfg.feed, 8000], [this.cfg.fallback, 8000]]) {
            if (!url) continue;
            try {
              data = await this.fetchJson(url, ms);
              break;
            } catch (error) {
              console.warn('[mf-cards] feed unavailable', url, error);
            }
          }
          if (!data) {
            this.status('Cards are taking a moment to load. Refresh the page to try again.');
            this.el('[data-grid]').innerHTML = '';
            return;
          }
          this.ingest(data);
        }

        ingest(data) {
          const toCard = (row) => {
            const card = Object.fromEntries(data.fields.map((field, i) => [field, row[i]]));
            card.id = String(card.id);
            return card;
          };
          this.types = data.types || {};
          this.leagues = data.leagues || {};
          this.cards = data.cards.map(toCard);
          this.byId = new Map(this.cards.map((card) => [card.id, card]));
          this.cols = new Map(
            data.collections.map((col) => [
              col.key,
              { ...col, preview: (col.preview || []).map(toCard), includes: new Set((col.includes || []).map(String)) },
            ])
          );
          this.restore();
          this.renderHero();
          this.renderFeatured();
          this.renderCollections();
          this.renderOptions();
          this.renderGrid();
          this.sync();
        }

        status(message) {
          const el = this.el('[data-status]');
          el.textContent = message;
          el.hidden = !message;
        }

        label(card) {
          return `${card.name} ${card.rating} · ${this.types[card.type] || card.type}`;
        }

        colOffer(key) {
          if (key === `${SPECIAL}evo`) return this.offer('evos');
          if (key.startsWith(SPECIAL)) return this.offer('special');
          return this.offer(key);
        }

        canBuy(key) {
          return this.cols.has(key) && !!this.colOffer(key) && (key !== BUNDLE || TIERS.every((tier) => this.cols.has(tier)));
        }

        /* ---------- markup ---------- */

        rarity(card) {
          if (this.byId.has(card.id)) return 'black';
          const tier = (card.type || '').match(TIER_RARITY);
          return tier ? tier[1] : 'cyan';
        }

        cardMarkup(card, extra = '') {
          const art = card.art ? `<img src="${esc(card.art)}" alt="" loading="lazy" decoding="async">` : '';
          return `<span class="mf-card27 mf-card27--${this.rarity(card)} ${extra}">
            <span class="mf-card27__body">
              <span class="mf-card27__frame">
                <span class="mf-card27__top">
                  <span class="mf-card27__value">${esc(card.rating)}</span>
                  <span class="mf-card27__unit">${esc(card.position)}</span>
                </span>
                <span class="mf-card27__art">${art}</span>
                <span class="mf-card27__name">${esc(card.name.length > 13 ? card.name.split(' ').pop() : card.name)}</span>
                <span class="mf-card27__price" data-card-price></span>
              </span>
              <span class="mf-card27__foil" aria-hidden="true"></span>
            </span>
          </span>`;
        }

        fanMarkup(cards) {
          return cards
            .slice(0, 3)
            .map((card, i) => `<span class="mf-cards__slot mf-cards__fan-slot mf-cards__fan-slot--${i + 1}">${this.cardMarkup(card)}</span>`)
            .join('');
        }

        renderHero() {
          const fmt = (n) => new Intl.NumberFormat(this.cfg.locale || undefined).format(n);
          const tiers = this.cols.get(BUNDLE);
          const specials = [...this.cols.keys()].filter((key) => key.startsWith(SPECIAL));
          this.el('[data-stat="singles"]').textContent = this.offer('card') ? fmt(this.cards.length) : 'Soon';
          const compact = new Intl.NumberFormat(this.cfg.locale || undefined, { notation: 'compact', maximumFractionDigits: 0 });
          this.el('[data-stat="tiers"]').textContent = tiers ? (tiers.count >= 10000 ? `${compact.format(tiers.count)}+` : fmt(tiers.count)) : 'Soon';
          this.el('[data-stat="specials"]').textContent = specials.length ? fmt(specials.length) : 'Soon';
        }

        colPanel(key, kind) {
          const col = this.cols.get(key);
          const offer = this.colOffer(key);
          const count = new Intl.NumberFormat(this.cfg.locale || undefined).format(col.count);
          const tint = kind === 'special' ? 'cyan' : key;
          const price = offer ? `<span class="mf-price__now">${this.money.format(offer.price / 100)}</span>` : '';
          return `<article class="mf-panel mf-cards__col mf-cards__col--${esc(tint)}" data-col-panel="${esc(key)}">
            <div class="mf-cards__mini-fan">${this.fanMarkup(col.preview)}</div>
            <div class="mf-cards__col-body">
              <p class="mf-cards__col-count">${count} cards</p>
              <h3 class="mf-cards__col-title">${esc(col.label)}</h3>
              <div class="mf-price">${price}</div>
              <button type="button" class="mf-btn mf-btn--ghost mf-btn--sm mf-btn--block" data-toggle-col="${esc(key)}"></button>
            </div>
          </article>`;
        }

        featuredGroups() {
          const groups = [];
          const golds = this.cards.filter((card) => card.type === 'rare_gold');
          if (golds.length >= 3) {
            groups.push({
              key: 'golds',
              tint: 'gold',
              kicker: 'Rare gold trio',
              title: 'The 91s',
              text: 'Haaland, Mbappé and Putellas. Three untradeable rare golds.',
              cards: golds.slice(0, 3),
            });
          }
          const evos = this.cards.filter((card) => /evo/i.test(card.type));
          if (evos.length) {
            groups.push({
              key: 'evos',
              tint: 'black',
              kicker: 'Skip the grind',
              title: 'Evolutions',
              text: 'Finished evo cards, added to your club. No objectives.',
              cards: evos,
              col: this.canBuy('special:evo') ? 'special:evo' : null,
            });
          }
          return groups;
        }

        renderFeatured() {
          const wrap = this.el('[data-featured]');
          const groups = this.offer('card') ? this.featuredGroups() : [];
          wrap.hidden = !groups.length;
          wrap.innerHTML = groups
            .map((group) => {
              const ids = group.cards.map((card) => card.id);
              return `<article class="mf-panel mf-tint--${group.tint} mf-cards__deal" data-featured-group="${group.key}">
                <div class="mf-cards__deal-copy">
                  <p class="mf-tag">${esc(group.kicker)}</p>
                  <h3 class="mf-cards__deal-title">${esc(group.title)}</h3>
                  <p class="mf-cards__deal-text">${esc(group.text)}</p>
                  ${group.col
                    ? `<button type="button" class="mf-btn mf-btn--primary mf-btn--sm" data-featured-col="${esc(group.col)}" data-featured-size="${ids.length}"></button>`
                    : `<button type="button" class="mf-btn mf-btn--primary mf-btn--sm" data-add-featured="${ids.join(',')}"></button>`}
                </div>
                <div class="mf-cards__mini-fan mf-cards__deal-fan">${this.fanMarkup(group.cards)}</div>
              </article>`;
            })
            .join('');
        }

        renderCollections() {
          const tiers = TIERS.filter((key) => this.cols.has(key));
          this.el('[data-tiers]').innerHTML = tiers.length
            ? tiers.map((key) => this.colPanel(key, 'tier')).join('')
            : `<p class="mf-cards__soon">Bronze, Silver and Gold collections are coming soon.</p>`;

          const bundle = this.cols.get(BUNDLE);
          const bundleOffer = this.offer(BUNDLE);
          if (bundle && tiers.length === 3) {
            const separate = TIERS.reduce((sum, key) => sum + (this.cfg.offers[key]?.price || 0), 0);
            const price = bundleOffer?.price || 0;
            const save = separate - price;
            const pct = separate ? Math.round((save / separate) * 100) : 0;
            const count = new Intl.NumberFormat(this.cfg.locale || undefined).format(bundle.count);
            const previews = TIERS.map((key) => this.cols.get(key).preview[0]).filter(Boolean).reverse();
            this.el('[data-bundle]').innerHTML = `<article class="mf-panel mf-tint--gold mf-cards__bundle" data-col-panel="${BUNDLE}">
              <div class="mf-cards__bundle-copy">
                <p class="mf-tag">Best value · ${count} cards</p>
                <h3 class="mf-cards__bundle-title">${esc(bundle.label)}</h3>
                <p class="mf-lede">Every Bronze, Silver and Gold card in MadFUT 27. The fastest way to a complete club.</p>
                <div class="mf-price">
                  ${bundleOffer ? `<span class="mf-price__now">${this.money.format(price / 100)}</span>` : ''}
                  ${bundleOffer && save > 0 ? `<span class="mf-price__was">${this.money.format(separate / 100)}</span><span class="mf-price__save">Save ${this.money.format(save / 100)} (${pct}%)</span>` : ''}
                </div>
                <button type="button" class="mf-btn mf-btn--primary" data-toggle-col="${BUNDLE}"></button>
              </div>
              <div class="mf-cards__mini-fan mf-cards__mini-fan--wide">${this.fanMarkup(previews)}</div>
            </article>`;
          } else {
            this.el('[data-bundle]').innerHTML = '';
          }

          const specials = [...this.cols.keys()].filter((key) => key.startsWith(SPECIAL) && this.cols.get(key).count > 0);
          this.el('[data-specials-wrap]').hidden = !specials.length;
          const shown = specials.length <= SPECIALS_SHOWN ? specials.length : SPECIALS_FOLDED;
          this.el('[data-specials]').innerHTML = specials
            .map((key, i) => this.colPanel(key, 'special').replace('<article ', `<article ${i >= shown ? 'data-extra-special ' : ''}`))
            .join('');
          const more = this.el('[data-more-specials]');
          more.hidden = shown === specials.length;
          more.textContent = `Show all ${specials.length} promo collections`;
          this.toggleSpecials(false);
        }

        toggleSpecials(open) {
          this.specialsOpen = open;
          for (const el of this.querySelectorAll('[data-extra-special]')) el.hidden = !open;
          const more = this.el('[data-more-specials]');
          if (open) more.hidden = true;
        }

        renderOptions() {
          const fill = (name, entries) => {
            const select = this.el(`[data-filter="${name}"]`);
            const first = select.options[0];
            select.replaceChildren(first, ...entries.map(([value, text]) => new Option(text, value)));
            select.closest('label').hidden = entries.length < 2;
          };
          const types = [...new Set(this.cards.map((card) => card.type))].map((type) => [type, this.types[type] || type]);
          const leagues = [...new Set(this.cards.map((card) => String(card.league)))]
            .filter((id) => this.leagues[id])
            .map((id) => [id, this.leagues[id]]);
          const chips = this.el('[data-chips]');
          chips.hidden = types.length < 2;
          chips.innerHTML = [['', 'All'], ...types.sort((a, b) => a[1].localeCompare(b[1]))]
            .map(([value, text]) => `<button type="button" class="mf-cards__chip" data-chip="${esc(value)}" aria-pressed="${value === this.filters.type}">${esc(text)}</button>`)
            .join('');
          fill('league', leagues.sort((a, b) => a[1].localeCompare(b[1])));
        }

        filtered() {
          const { q, type, pos, league, sort } = this.filters;
          const needle = q.trim().toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');
          const list = this.cards.filter(
            (card) =>
              (!needle || card.name.toLowerCase().normalize('NFD').replace(/\p{M}/gu, '').includes(needle)) &&
              (!type || card.type === type) &&
              (!pos || POSITIONS[pos].includes(card.position)) &&
              (!league || String(card.league) === league)
          );
          const byName = (a, b) => a.name.localeCompare(b.name);
          if (sort === 'name') return list.sort(byName);
          if (sort === 'rating-asc') return list.sort((a, b) => a.rating - b.rating || byName(a, b));
          return list.sort((a, b) => b.rating - a.rating || byName(a, b));
        }

        renderGrid() {
          const grid = this.el('[data-grid]');
          if (!this.offer('card')) {
            grid.innerHTML = '';
            this.el('[data-count]').textContent = '';
            this.el('[data-empty]').hidden = false;
            this.el('[data-empty]').textContent = 'Individual cards are coming soon.';
            this.el('[data-more]').hidden = true;
            this.el('.mf-cards__toolbar').hidden = true;
            this.el('[data-ladder]').hidden = true;
            return;
          }
          const list = this.filtered();
          const shown = list.slice(0, this.limit);
          grid.innerHTML = shown
            .map(
              (card) => `<button type="button" class="mf-cards__pick" data-toggle-card="${esc(card.id)}" aria-pressed="false" aria-label="${esc(this.label(card))}">
                <span class="mf-cards__slot">${this.cardMarkup(card)}</span>
                <span class="mf-cards__pick-cta" data-pick-cta></span>
                <span class="mf-cards__pick-meta">${esc(this.types[card.type] || card.type)}${this.leagues[card.league] ? ` · ${esc(this.leagues[card.league])}` : ''}</span>
              </button>`
            )
            .join('');
          this.el('[data-count]').textContent = `${list.length} ${list.length === 1 ? 'card' : 'cards'}`;
          this.el('[data-empty]').hidden = list.length > 0;
          const more = this.el('[data-more]');
          more.hidden = list.length <= shown.length;
          more.textContent = `Show more cards (${list.length - shown.length})`;
          this.sync();
        }

        /* ---------- selection ---------- */

        coveredBy(id) {
          for (const key of this.sel.cols) {
            if (this.cols.get(key)?.includes.has(id)) return key;
          }
          return null;
        }

        toggleCard(id) {
          if (!this.byId.has(id) || this.coveredBy(id)) return;
          const card = this.byId.get(id);
          if (this.sel.cards.includes(id)) {
            this.sel.cards = this.sel.cards.filter((x) => x !== id);
            this.announce(`Removed ${card.name}`);
          } else {
            this.sel.cards.push(id);
            this.announce(`Added ${card.name}`);
          }
        }

        toggleCol(key) {
          if (this.sel.cols.includes(key)) {
            this.sel.cols = this.sel.cols.filter((x) => x !== key);
            this.announce(`Removed ${this.cols.get(key).label}`);
            return;
          }
          if (!this.canBuy(key)) return;
          if (TIERS.includes(key) && this.sel.cols.includes(BUNDLE)) return;
          if (key === BUNDLE) this.sel.cols = this.sel.cols.filter((x) => !TIERS.includes(x));
          this.sel.cols.push(key);
          const includes = this.cols.get(key).includes;
          const dropped = this.sel.cards.filter((id) => includes.has(id));
          this.sel.cards = this.sel.cards.filter((id) => !includes.has(id));
          const label = this.cols.get(key).label;
          this.announce(
            dropped.length
              ? `Added ${label}. ${dropped.length} selected ${dropped.length === 1 ? 'card is' : 'cards are'} already in it, so we removed ${dropped.length === 1 ? 'it' : 'them'}.`
              : `Added ${label}`,
            dropped.length > 0
          );
        }

        toggleExtra(key) {
          if (this.sel.extras.includes(key)) this.sel.extras = this.sel.extras.filter((x) => x !== key);
          else if (this.offer(key)) this.sel.extras.push(key);
        }

        restore() {
          try {
            const saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
            if (!saved) return;
            this.sel.cards = (saved.cards || []).filter((id) => this.byId.has(id));
            this.sel.cols = (saved.cols || []).filter((key) => this.canBuy(key));
            this.sel.extras = (saved.extras || []).filter((key) => this.offer(key));
            this.sel.cards = this.sel.cards.filter((id) => !this.coveredBy(id));
          } catch (error) {
            sessionStorage.removeItem(STORE_KEY);
          }
        }

        save() {
          try {
            sessionStorage.setItem(STORE_KEY, JSON.stringify(this.sel));
          } catch (error) {}
        }

        announce(message, visible = false) {
          this.el('[data-announce]').textContent = message;
          if (visible) this.notice = message;
        }

        /* ---------- totals ---------- */

        pct(count) {
          let pct = 0;
          for (const [qty, off] of this.ladder) if (count >= qty) pct = off;
          return pct;
        }

        totals() {
          const card = this.offer('card');
          const n = this.sel.cards.length;
          const pct = this.pct(n);
          const unit = card ? card.price : 0;
          const unitNow = unit - Math.floor((unit * pct) / 100);
          let was = n * unit;
          let now = n * unitNow;
          for (const key of this.sel.cols) {
            const offer = this.colOffer(key);
            if (!offer) continue;
            now += offer.price;
            was += key === BUNDLE ? TIERS.reduce((sum, tier) => sum + (this.cfg.offers[tier]?.price || 0), 0) : offer.price;
          }
          for (const key of this.sel.extras) {
            const offer = this.offer(key);
            if (!offer) continue;
            now += offer.price;
            was += offer.price;
          }
          return { n, pct, unit, unitNow, was, now };
        }

        /* ---------- state sync ---------- */

        sync() {
          this.save();
          const t = this.totals();
          const fmt = (cents) => this.money.format(cents / 100);
          const bundleOn = this.sel.cols.includes(BUNDLE);

          for (const btn of this.querySelectorAll('[data-toggle-card]')) {
            const id = btn.dataset.toggleCard;
            const on = this.sel.cards.includes(id);
            const cover = this.coveredBy(id);
            btn.setAttribute('aria-pressed', on);
            btn.classList.toggle('is-selected', on);
            btn.classList.toggle('is-covered', !!cover);
            btn.disabled = !!cover;
            btn.querySelector('[data-pick-cta]').textContent = cover
              ? `In ${this.cols.get(cover).label.replace(/^Complete /, '')}`
              : on
                ? '✓ Added'
                : `+ ${fmt(t.pct ? t.unitNow : t.unit)}`;
          }

          for (const btn of this.querySelectorAll('[data-add-featured]')) {
            const ids = btn.dataset.addFeatured.split(',').filter(Boolean);
            const allOn = ids.every((id) => this.sel.cards.includes(id) || this.coveredBy(id));
            const extra = ids.filter((id) => !this.sel.cards.includes(id) && !this.coveredBy(id));
            const would = this.sel.cards.length + extra.length;
            const each = t.unit - Math.floor((t.unit * this.pct(would)) / 100);
            btn.textContent = allOn ? 'Added ✓' : `Add all ${ids.length} · ${fmt(extra.length * each)}`;
            btn.closest('[data-featured-group]')?.classList.toggle('is-selected', allOn);
          }

          for (const btn of this.querySelectorAll('[data-featured-col]')) {
            const key = btn.dataset.featuredCol;
            const on = this.sel.cols.includes(key);
            btn.setAttribute('aria-pressed', on);
            btn.textContent = on ? 'Added ✓' : `Add all ${btn.dataset.featuredSize} · ${fmt(this.colOffer(key)?.price || 0)}`;
            btn.closest('[data-featured-group]')?.classList.toggle('is-selected', on);
          }

          for (const btn of this.querySelectorAll('[data-toggle-col]')) {
            const key = btn.dataset.toggleCol;
            const on = this.sel.cols.includes(key);
            const inBundle = bundleOn && TIERS.includes(key);
            btn.setAttribute('aria-pressed', on);
            btn.disabled = !on && (!this.canBuy(key) || inBundle);
            const short = key !== BUNDLE;
            btn.textContent = !this.canBuy(key)
              ? 'Coming soon'
              : inBundle
                ? 'In bundle'
                : on
                  ? 'Added ✓'
                  : short
                    ? 'Add'
                    : 'Add the bundle';
            btn.title = on ? 'Remove from selection' : '';
            btn.closest('[data-col-panel]')?.classList.toggle('is-selected', on || inBundle);
          }

          for (const btn of this.querySelectorAll('[data-extra]')) {
            const key = btn.dataset.extra;
            const offer = this.offer(key);
            const on = this.sel.extras.includes(key);
            btn.disabled = !offer;
            btn.setAttribute('aria-pressed', on);
            btn.classList.toggle('is-selected', on);
            btn.querySelector('[data-extra-price]').textContent = offer ? fmt(offer.price) : '';
            btn.querySelector('[data-extra-state]').textContent = !offer ? 'Unavailable' : on ? 'Added ✓' : 'Add';
          }

          this.syncLadder(t);
          this.syncTray(t);
        }

        syncLadder(t) {
          if (!this.offer('card')) return;
          const fmt = (cents) => this.money.format(cents / 100);
          const steps = [[1, 0], ...this.ladder];
          this.el('[data-ladder-steps]').innerHTML = steps
            .map(([qty, pct], i) => {
              const next = steps[i + 1];
              const range = next ? (next[0] - 1 > qty ? `${qty}–${next[0] - 1}` : `${qty}`) : `${qty}+`;
              const each = fmt(t.unit - Math.floor((t.unit * pct) / 100));
              const active = t.n >= qty && (!next || t.n < next[0]);
              return `<li class="${active && t.n ? 'is-active' : ''} ${t.n >= qty ? 'is-reached' : ''}">
                <span class="mf-cards__ladder-qty">${range} ${qty === 1 && next?.[0] === 2 ? 'card' : 'cards'}</span>
                <span class="mf-cards__ladder-each">${each}<small> each</small></span>
                <span class="mf-cards__ladder-off">${pct ? `${pct}% off` : 'Full price'}</span>
              </li>`;
            })
            .join('');
          const top = this.ladder[this.ladder.length - 1];
          this.el('[data-ladder-fill]').style.width = `${top ? Math.min(100, (t.n / top[0]) * 100) : 0}%`;
          const nextStep = this.ladder.find(([qty]) => t.n < qty);
          this.el('[data-ladder-hint]').textContent = nextStep
            ? `${t.n ? `${t.n} selected. ` : ''}Add ${nextStep[0] - t.n} more ${nextStep[0] - t.n === 1 ? 'card' : 'cards'} to get ${nextStep[1]}% off every card.`
            : `${t.pct}% off every card is applied at checkout.`;
        }

        trayItems() {
          const items = [];
          for (const key of this.sel.cols) {
            const col = this.cols.get(key);
            const offer = this.colOffer(key);
            items.push({ kind: 'col', key, card: col.preview[0], title: col.label, sub: `${col.count.toLocaleString()} cards`, price: offer?.price || 0 });
          }
          const t = this.totals();
          for (const id of this.sel.cards) {
            const card = this.byId.get(id);
            items.push({ kind: 'card', key: id, card, title: `${card.name} ${card.rating}`, sub: this.types[card.type] || card.type, price: t.unitNow });
          }
          for (const key of this.sel.extras) {
            const offer = this.offer(key);
            items.push({ kind: 'extra', key, title: offer.title, sub: 'Add-on', price: offer.price });
          }
          return items;
        }

        syncTray(t) {
          const tray = this.el('[data-tray]');
          const items = this.trayItems();
          const fmt = (cents) => this.money.format(cents / 100);
          tray.hidden = !items.length;
          document.body.classList.toggle('mf-cards-tray-open', items.length > 0);
          if (!items.length) {
            this.setTrayOpen(false);
            return;
          }

          this.el('[data-tray-thumbs]').innerHTML = items
            .filter((item) => item.card)
            .slice(0, 4)
            .map((item) => `<span class="mf-cards__thumb mf-cards__thumb--${this.rarity(item.card)}">${item.card.art ? `<img src="${esc(item.card.art)}" alt="" loading="lazy">` : ''}</span>`)
            .join('');
          this.el('[data-tray-count]').textContent = `${items.length} ${items.length === 1 ? 'item' : 'items'}`;

          const allTiers = TIERS.every((key) => this.sel.cols.includes(key));
          const nextStep = this.ladder.find(([qty]) => t.n > 0 && t.n < qty);
          let hint = '';
          if (this.notice) hint = this.notice;
          else if (allTiers && this.canBuy(BUNDLE)) hint = 'Switch to the bundle and pay less';
          else if (t.pct) hint = `${t.pct}% card discount applied`;
          else if (nextStep) hint = `Add ${nextStep[0] - t.n} more for ${nextStep[1]}% off`;
          this.el('[data-tray-hint]').textContent = hint;
          this.notice = '';

          this.el('[data-tray-was]').textContent = t.was > t.now ? fmt(t.was) : '';
          this.el('[data-tray-now]').textContent = fmt(t.now);

          const swap =
            allTiers && this.canBuy(BUNDLE)
              ? `<button type="button" class="mf-cards__swap" data-swap-bundle>Swap the three tiers for the bundle${this.offer(BUNDLE) ? ` · ${fmt(this.offer(BUNDLE).price)}` : ''}</button>`
              : '';
          this.el('[data-tray-list]').innerHTML = `<div class="mf__container">
            ${swap}
            <ul>${items
              .map(
                (item) => `<li>
                  <span class="mf-cards__thumb mf-cards__thumb--${item.card ? this.rarity(item.card) : 'violet'}">${item.card?.art ? `<img src="${esc(item.card.art)}" alt="" loading="lazy">` : ''}</span>
                  <span class="mf-cards__tray-item"><b>${esc(item.title)}</b><small>${esc(item.sub)}</small></span>
                  <span class="mf-cards__tray-price">${fmt(item.price)}</span>
                  <button type="button" class="mf-cards__remove" data-remove="${esc(item.kind)}:${esc(item.key)}" aria-label="Remove ${esc(item.title)}">×</button>
                </li>`
              )
              .join('')}</ul>
            <p class="mf-cards__tray-note">Everything in your order is delivered together, in seconds.</p>
          </div>`;
        }

        setTrayOpen(open) {
          const toggle = this.el('[data-tray-toggle]');
          toggle.setAttribute('aria-expanded', open);
          this.el('[data-tray-list]').hidden = !open;
          this.el('[data-tray]').classList.toggle('is-open', open);
        }

        /* ---------- events ---------- */

        onClick(event) {
          const target = event.target.closest('button');
          if (!target || !this.contains(target)) return;
          const d = target.dataset;
          if (d.toggleCard) this.toggleCard(d.toggleCard);
          else if (d.addFeatured) {
            const ids = d.addFeatured.split(',').filter((id) => this.byId.has(id) && !this.coveredBy(id));
            const allOn = ids.every((id) => this.sel.cards.includes(id));
            if (allOn) this.sel.cards = this.sel.cards.filter((id) => !ids.includes(id));
            else for (const id of ids) if (!this.sel.cards.includes(id)) this.sel.cards.push(id);
          }
          else if (d.toggleCol) this.toggleCol(d.toggleCol);
          else if (d.featuredCol) this.toggleCol(d.featuredCol);
          else if (d.extra) this.toggleExtra(d.extra);
          else if (d.swapBundle !== undefined) this.toggleCol(BUNDLE);
          else if (d.chip !== undefined) {
            this.filters.type = d.chip;
            for (const chip of this.querySelectorAll('[data-chip]')) chip.setAttribute('aria-pressed', chip === target);
            this.limit = this.page;
            this.renderGrid();
            return;
          }
          else if (d.remove) {
            const [kind, ...rest] = d.remove.split(':');
            const key = rest.join(':');
            if (kind === 'card') this.sel.cards = this.sel.cards.filter((x) => x !== key);
            if (kind === 'col') this.sel.cols = this.sel.cols.filter((x) => x !== key);
            if (kind === 'extra') this.sel.extras = this.sel.extras.filter((x) => x !== key);
          } else if (d.trayToggle !== undefined) {
            this.setTrayOpen(target.getAttribute('aria-expanded') !== 'true');
            return;
          } else if (d.more !== undefined) {
            this.limit += this.page;
            this.renderGrid();
            return;
          } else if (d.moreSpecials !== undefined) {
            this.toggleSpecials(true);
            return;
          } else if (d.checkout !== undefined) {
            this.checkout(target);
            return;
          } else return;
          this.sync();
        }

        onFilter(event) {
          const name = event.target.dataset?.filter;
          if (!name || this.filters[name] === event.target.value) return;
          this.filters[name] = event.target.value;
          this.limit = this.page;
          this.renderGrid();
        }

        /* ---------- checkout ---------- */

        lineItems() {
          const items = [];
          const card = this.offer('card');
          for (const id of this.sel.cards) {
            const c = this.byId.get(id);
            items.push({ id: card.variant, quantity: 1, properties: { Card: this.label(c), _card_id: id } });
          }
          for (const key of this.sel.cols) {
            const offer = this.colOffer(key);
            if (key.startsWith(SPECIAL)) {
              items.push({ id: offer.variant, quantity: 1, properties: { Collection: this.cols.get(key).label, _collection: key } });
            } else {
              items.push({ id: offer.variant, quantity: 1 });
            }
          }
          for (const key of this.sel.extras) items.push({ id: this.offer(key).variant, quantity: 1 });
          return items;
        }

        lineKey(item) {
          const props = item.properties || {};
          if (props._card_id) return `card:${props._card_id}`;
          if (props._collection) return `col:${props._collection}`;
          return `variant:${item.variant_id || item.id}`;
        }

        async checkout(button) {
          const items = this.lineItems();
          if (!items.length) return;
          const label = button.innerHTML;
          button.disabled = true;
          button.textContent = 'Securing checkout…';
          try {
            const cart = await fetch(this.cfg.cartUrl, { headers: { Accept: 'application/json' } }).then((res) => res.json());
            const inCart = new Set((cart.items || []).map((item) => this.lineKey(item)));
            const toAdd = items.filter((item) => !inCart.has(this.lineKey(item)));
            if (toAdd.length) {
              const res = await fetch(this.cfg.cartAddUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: toAdd }),
              });
              if (!res.ok) {
                const body = await res.json().catch(() => ({}));
                throw new Error(body.description || 'Could not add to cart');
              }
            }
            sessionStorage.removeItem(STORE_KEY);
            window.location.href = this.cfg.checkoutUrl;
          } catch (error) {
            console.error('[mf-cards] checkout', error);
            button.disabled = false;
            button.innerHTML = label;
            this.el('[data-tray-hint]').textContent = `${error.message}. Please try again.`;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-filter')) {
    customElements.define(
      'mf-filter',
      class extends HTMLElement {
        connectedCallback() {
          this.chips = [...this.querySelectorAll('[data-filter]')];
          this.groups = [...this.querySelectorAll('[data-group]')];
          for (const chip of this.chips) {
            if (chip.dataset.filter && !this.groups.some((group) => group.dataset.group === chip.dataset.filter)) chip.hidden = true;
            chip.addEventListener('click', () => this.apply(chip));
          }
          const initial = new URL(window.location.href).searchParams.get('game');
          const match = this.chips.find((chip) => chip.dataset.filter && chip.dataset.filter === initial && !chip.hidden);
          if (match) this.apply(match);
        }

        apply(active) {
          for (const chip of this.chips) chip.setAttribute('aria-pressed', String(chip === active));
          for (const group of this.groups) {
            group.hidden = Boolean(active.dataset.filter) && group.dataset.group !== active.dataset.filter;
          }
          const url = new URL(window.location.href);
          if (active.dataset.filter) url.searchParams.set('game', active.dataset.filter);
          else url.searchParams.delete('game');
          window.history.replaceState({}, '', url);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-help"] && !Shopify.designMode) return;
  try {
    
  class MfHelp extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search]');
      this.items = [...this.querySelectorAll('[data-item]')];
      this.groups = [...this.querySelectorAll('[data-group]')];
      this.empty = this.querySelector('[data-empty]');
      this.input?.addEventListener('input', () => this.filter(this.input.value));
      window.addEventListener('hashchange', () => this.openHash());
      this.openHash();
    }

    openHash() {
      const id = decodeURIComponent(location.hash.slice(1));
      const target = id ? document.getElementById(id) : null;
      if (target?.matches('[data-item]')) {
        target.open = true;
        target.scrollIntoView({ block: 'center' });
      }
    }

    filter(raw) {
      const words = raw.toLowerCase().trim().split(/\s+/).filter(Boolean);
      let shown = 0;
      this.items.forEach((item) => {
        const text = item.textContent.toLowerCase();
        const match = words.every((word) => text.includes(word));
        item.hidden = !match;
        if (words.length) item.open = match && words.join('').length > 2;
        if (match) shown += 1;
      });
      this.groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-item]:not([hidden])');
      });
      if (!words.length) this.items.forEach((item) => (item.open = false));
      this.empty.hidden = shown > 0;
    }
  }

  if (!customElements.get('mf-help')) customElements.define('mf-help', MfHelp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-countdown')) {
    customElements.define(
      'mf-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end || '');
          if (!Number.isFinite(this.end) || this.end <= Date.now()) return;
          this.units = {};
          for (const el of this.querySelectorAll('[data-unit]')) this.units[el.dataset.unit] = el;
          this.hidden = false;
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const left = Math.max(0, this.end - Date.now());
          if (left === 0) {
            clearInterval(this.timer);
            this.hidden = true;
            return;
          }
          const s = Math.floor(left / 1000);
          const parts = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
          for (const [key, value] of Object.entries(parts)) {
            if (this.units[key]) this.units[key].textContent = String(value).padStart(2, '0');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-level-gate"] && !Shopify.designMode) return;
  try {
    
  const mfLgReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class MfLgVault extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.lv = this.querySelector('[data-ref="lv"]');
      this.fill = this.querySelector('[data-ref="fill"]');
      this.ticks = [...this.querySelectorAll('[data-tick]')];
      if (mfLgReduced()) {
        this.finish(true);
        return;
      }
      this.io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.io.disconnect();
          setTimeout(() => this.play(), 250);
        },
        { threshold: 0.3 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }

    set(p) {
      const lvl = 1 + Math.round(p * 24);
      if (this.lv) this.lv.textContent = String(lvl);
      if (this.fill) this.fill.style.strokeDashoffset = String(100 - p * 100);
      this.ticks.forEach((t, i) => t.classList.toggle('is-on', i < lvl));
    }

    play() {
      const start = performance.now();
      const dur = 1900;
      const step = (now) => {
        const t = Math.min(1, (now - start) / dur);
        this.set(1 - Math.pow(1 - t, 3));
        if (t < 1) requestAnimationFrame(step);
        else this.finish(false);
      };
      requestAnimationFrame(step);
    }

    finish(instant) {
      this.set(1);
      this.classList.add('is-unlocked');
      if (instant) {
        this.classList.add('is-open', 'is-done');
        return;
      }
      setTimeout(() => this.classList.add('is-open'), 650);
    }
  }

  class MfLgClimb extends HTMLElement {
    connectedCallback() {
      this.rungs = [...this.querySelectorAll('.mf-lg-rung')];
      this.stages = [...this.querySelectorAll('[data-stage]')];
      this.token = this.querySelector('[data-ref="token"]');
      this.count = this.querySelector('[data-ref="count"]');
      this.level = 0;
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    update() {
      const rect = this.getBoundingClientRect();
      const travel = Math.max(1, this.offsetHeight - window.innerHeight);
      const p = Math.min(1, Math.max(0, -rect.top / travel / 0.82));
      const lvl = 1 + Math.round(p * 24);
      this.style.setProperty('--p', p.toFixed(4));
      this.placeToken(lvl);
      if (lvl === this.level) return;
      this.level = lvl;
      if (this.count) this.count.textContent = String(lvl);
      this.rungs.forEach((r) => {
        const n = Number(r.dataset.lv);
        r.classList.toggle('is-passed', n <= lvl);
        r.classList.toggle('is-here', n === lvl);
      });
      const stage = lvl >= 25 ? 25 : lvl >= 20 ? 20 : lvl >= 10 ? 10 : 1;
      this.stages.forEach((s) => s.classList.toggle('is-active', Number(s.dataset.stage) === stage));
      this.classList.toggle('is-unlocked', lvl >= 25);
    }

    placeToken(lvl) {
      const rung = this.rungs.find((r) => Number(r.dataset.lv) === lvl);
      if (!rung || !this.token) return;
      const y = rung.offsetTop + rung.offsetHeight / 2;
      this.token.style.transform = `translate(-50%, calc(${y}px - 50%))`;
    }
  }

  class MfLgInview extends HTMLElement {
    connectedCallback() {
      this.io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.classList.add('is-in');
          this.io.disconnect();
        },
        { threshold: 0.45 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }
  }

  class MfLgKeyline extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('.mf-lg-key__step')];
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-lit');
            this.io.unobserve(e.target);
          });
          if (this.steps.every((s) => s.classList.contains('is-lit'))) {
            this.classList.add('is-turned');
            this.io.disconnect();
          }
        },
        { threshold: 0.6 }
      );
      this.steps.forEach((s) => this.io.observe(s));
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }
  }

  if (!customElements.get('mf-lg-vault')) customElements.define('mf-lg-vault', MfLgVault);
  if (!customElements.get('mf-lg-climb')) customElements.define('mf-lg-climb', MfLgClimb);
  if (!customElements.get('mf-lg-inview')) customElements.define('mf-lg-inview', MfLgInview);
  if (!customElements.get('mf-lg-keyline')) customElements.define('mf-lg-keyline', MfLgKeyline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-modmenu"] && !Shopify.designMode) return;
  try {
    
  const mfMmReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const mfMmCount = (el, dur = 1400) => {
    const to = Number(el.dataset.count);
    const suffix = el.dataset.suffix || '';
    if (mfMmReduced()) {
      el.textContent = to.toLocaleString('en-US') + suffix;
      return;
    }
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / dur);
      el.textContent = Math.round(to * (1 - Math.pow(1 - t, 3))).toLocaleString('en-US') + suffix;
      if (t < 1 && el.isConnected) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  class MfMmPillars extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.index = 0;
      this.auto = !mfMmReduced();
      this.onClick = (e) => {
        const tab = e.target.closest('[role="tab"]');
        if (!tab) return;
        this.stopAuto();
        this.show(this.tabs.indexOf(tab));
      };
      this.onKey = (e) => {
        if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
        if (!e.target.closest('[role="tab"]')) return;
        e.preventDefault();
        const dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1;
        this.stopAuto();
        this.show((this.index + dir + this.tabs.length) % this.tabs.length);
        this.tabs[this.index].focus();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.io = new IntersectionObserver((entries) => {
        this.visible = entries.some((e) => e.isIntersecting);
        this.classList.toggle('is-live', this.visible);
        if (this.visible && !this.started) {
          this.started = true;
          this.show(0);
        }
        this.sync();
      });
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.io?.disconnect();
      clearInterval(this.timer);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
    }

    stopAuto() {
      this.auto = false;
      this.classList.add('is-manual');
    }

    sync() {
      const run = this.auto && this.visible;
      if (run && !this.timer) this.timer = setInterval(() => this.show((this.index + 1) % this.tabs.length), 7000);
      if (!run && this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    show(i) {
      this.index = i;
      this.tabs.forEach((t, n) => {
        const on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((p, n) => {
        const on = n === i;
        p.hidden = !on;
        p.classList.remove('is-active');
        if (on) {
          void p.offsetWidth;
          p.classList.add('is-active');
          p.querySelectorAll('[data-count]').forEach((el) => mfMmCount(el));
        }
      });
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.sync();
    }
  }

  class MfMmLoadout extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.mf-mm-more__item')];
      this.fill = this.querySelector('[data-ref="fill"]');
      this.onEl = this.querySelector('[data-ref="on"]');
      this.tier = this.querySelector('[data-ref="tier"]');
      this.tiers = [
        [0, 'Standard player'],
        [1, 'Boosted'],
        [4, 'Stacked'],
        [8, 'Overpowered'],
        [this.items.length, 'Untouchable'],
      ];
      this.onClick = (e) => {
        const item = e.target.closest('.mf-mm-more__item');
        const action = e.target.closest('[data-action]')?.dataset.action;
        if (item) item.setAttribute('aria-pressed', item.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        if (action === 'all') this.cascade();
        if (action === 'reset') this.items.forEach((i) => i.setAttribute('aria-pressed', 'false'));
        if (item || action === 'reset') this.update();
      };
      this.addEventListener('click', this.onClick);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      clearTimeout(this.cascadeTimer);
    }

    cascade() {
      const off = this.items.filter((i) => i.getAttribute('aria-pressed') !== 'true');
      const delay = mfMmReduced() ? 0 : 70;
      const next = () => {
        const item = off.shift();
        if (!item) return;
        item.setAttribute('aria-pressed', 'true');
        this.update();
        this.cascadeTimer = setTimeout(next, delay);
      };
      next();
    }

    update() {
      const on = this.items.filter((i) => i.getAttribute('aria-pressed') === 'true').length;
      this.onEl.textContent = String(on);
      this.fill.style.transform = `scaleX(${on / this.items.length})`;
      let label = this.tiers[0][1];
      this.tiers.forEach(([min, name]) => {
        if (on >= min) label = name;
      });
      if (this.tier.textContent !== label) {
        this.tier.textContent = label;
        this.classList.remove('is-tier-up');
        void this.offsetWidth;
        if (on > 0) this.classList.add('is-tier-up');
      }
      this.classList.toggle('is-max', on === this.items.length);
    }
  }

  class MfMmQuiz extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.dots = [...this.querySelectorAll('.mf-mm-quiz__dots i')];
      this.restart = this.querySelector('[data-action="restart"]');
      this.status = this.querySelector('[data-ref="status"]');
      this.code = this.querySelector('[data-ref="code"]');
      this.depth = { device: 0, computer: 1, android: 2, emulator: 2, deal: 2 };
      this.onClick = (e) => {
        const go = e.target.closest('[data-go]')?.dataset.go;
        const action = e.target.closest('[data-action]')?.dataset.action;
        if (go) this.go(go);
        if (action === 'restart') this.go('device');
        if (action === 'copy') this.copy(e.target.closest('[data-action]'));
      };
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      clearInterval(this.scramble);
      clearTimeout(this.unlockTimer);
    }

    go(name) {
      this.steps.forEach((s) => {
        const on = s.dataset.step === name;
        s.hidden = !on;
        s.classList.toggle('is-active', on);
      });
      const depth = this.depth[name];
      this.dots.forEach((d, i) => d.classList.toggle('is-on', i <= depth));
      this.restart.hidden = name === 'device';
      const step = this.steps.find((s) => s.dataset.step === name);
      const q = step.querySelector('.mf-mm-quiz__q');
      if (q) this.status.textContent = q.textContent;
      if (name === 'deal') this.reveal(step);
      const first = step.querySelector('button, a');
      if (first && name !== 'device') first.focus({ preventScroll: true });
    }

    reveal(step) {
      const target = this.code.dataset.code;
      step.classList.remove('is-unlocked');
      clearInterval(this.scramble);
      clearTimeout(this.unlockTimer);
      if (mfMmReduced()) {
        this.code.textContent = target;
        step.classList.add('is-unlocked');
        return;
      }
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789';
      let frame = 0;
      this.scramble = setInterval(() => {
        frame += 1;
        const settled = Math.floor(frame / 3);
        this.code.textContent = [...target]
          .map((ch, i) => (i < settled ? ch : chars[Math.floor(Math.random() * chars.length)]))
          .join('');
        if (settled >= target.length) clearInterval(this.scramble);
      }, 45);
      this.unlockTimer = setTimeout(() => step.classList.add('is-unlocked'), 700);
    }

    async copy(btn) {
      const label = btn.querySelector('span');
      try {
        await navigator.clipboard.writeText(this.code.dataset.code);
        label.textContent = 'Copied';
      } catch (e) {
        label.textContent = 'Copy failed';
      }
      setTimeout(() => (label.textContent = 'Copy'), 1800);
    }
  }

  class MfMmTilt extends HTMLElement {
    connectedCallback() {
      if (mfMmReduced() || !window.matchMedia('(hover: hover)').matches) return;
      this.onMove = (e) => {
        const r = this.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        this.style.setProperty('--rx', `${(-y * 10).toFixed(2)}deg`);
        this.style.setProperty('--ry', `${(x * 14).toFixed(2)}deg`);
        this.style.setProperty('--sx', `${((x + 0.5) * 100).toFixed(1)}%`);
      };
      this.onLeave = () => {
        this.style.removeProperty('--rx');
        this.style.removeProperty('--ry');
        this.style.removeProperty('--sx');
      };
      this.addEventListener('pointermove', this.onMove);
      this.addEventListener('pointerleave', this.onLeave);
    }

    disconnectedCallback() {
      this.removeEventListener('pointermove', this.onMove);
      this.removeEventListener('pointerleave', this.onLeave);
    }
  }

  if (!customElements.get('mf-mm-pillars')) customElements.define('mf-mm-pillars', MfMmPillars);
  if (!customElements.get('mf-mm-loadout')) customElements.define('mf-mm-loadout', MfMmLoadout);
  if (!customElements.get('mf-mm-quiz')) customElements.define('mf-mm-quiz', MfMmQuiz);
  if (!customElements.get('mf-mm-tilt')) customElements.define('mf-mm-tilt', MfMmTilt);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-product')) {
    customElements.define(
      'mf-product',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.thumbs = [...this.querySelectorAll('[data-thumb]')];

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-option]')) this.onOptionChange();
          });
          this.querySelector('[data-hint]')?.addEventListener('click', () => this.goTo(1));
          for (const thumb of this.thumbs) {
            thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.thumb)));
          }

          this.watchSlides();
          this.watchStickyBar();
          this.setupDescription();
          this.setupVideos();
        }

        disconnectedCallback() {
          this.slideObserver?.disconnect();
          this.ctaObserver?.disconnect();
          this.videoObserver?.disconnect();
          this.galleryObserver?.disconnect();
        }

        setupVideos() {
          this.videos = [...this.querySelectorAll('[data-video]')];
          if (!this.videos.length) return;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.activeVideo = null;
          this.galleryVisible = false;

          const load = (video) => {
            if (video.src || !video.dataset.src) return;
            video.src = video.dataset.src;
            video.preload = 'auto';
          };

          this.galleryObserver = new IntersectionObserver(
            ([entry]) => {
              this.galleryVisible = entry.isIntersecting;
              if (entry.isIntersecting) this.videos.forEach(load);
              this.syncVideos();
            },
            { rootMargin: '200px 0px' }
          );
          this.galleryObserver.observe(this.track);

          this.videoObserver = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                const video = entry.target.querySelector('[data-video]');
                if (entry.isIntersecting) {
                  load(video);
                  if (this.activeVideo !== video) video.currentTime = 0;
                  this.activeVideo = video;
                } else if (this.activeVideo === video) {
                  this.activeVideo = null;
                }
              }
              this.syncVideos();
            },
            { root: this.track, threshold: 0.6 }
          );
          this.videos.forEach((video) => {
            if (this.reduceMotion) video.controls = true;
            this.videoObserver.observe(video.closest('[data-slide]'));
          });

          this.querySelectorAll('[data-sound]').forEach((button) => {
            const video = button.parentElement.querySelector('[data-video]');
            button.addEventListener('click', () => {
              video.muted = !video.muted;
              button.setAttribute('aria-pressed', String(!video.muted));
              button.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
              if (!video.muted && video.paused) video.play().catch(() => {});
            });
          });
        }

        syncVideos() {
          for (const video of this.videos) {
            const play = video === this.activeVideo && this.galleryVisible && !this.reduceMotion;
            if (play && video.paused) video.play().catch(() => {});
            if (!play && !video.paused) video.pause();
          }
        }

        onOptionChange() {
          const selected = [...this.querySelectorAll('fieldset')].map(
            (set) => set.querySelector('[data-option]:checked')?.value
          );
          const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
          if (!variant) return;

          this.querySelector('[data-variant-input]').value = variant.id;
          this.querySelectorAll('[data-price]').forEach((el) => (el.textContent = variant.price));
          this.querySelector('[data-compare]').textContent = variant.compare;
          this.querySelector('[data-compare]').hidden = !variant.hasSave;
          this.querySelector('[data-save]').hidden = !variant.hasSave;
          this.querySelector('[data-save-amount]').textContent = variant.save;
          this.querySelector('[data-save-percent]').textContent = variant.percent;
          this.querySelector('[data-stock]').hidden = !variant.available;

          this.querySelectorAll('[data-buy], [data-add]').forEach((button) => (button.disabled = !variant.available));
          this.querySelectorAll('[data-buy-label]').forEach((label) => {
            label.textContent = variant.available ? label.dataset.label : 'Sold out';
          });

          if (variant.media) {
            const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(variant.media));
            if (index > 0) this.goTo(index);
          }
          this.querySelector('mf-badge-picker')?.sync();

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        goTo(index) {
          const slide = this.slides[index];
          if (!slide) return;
          this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        }

        watchSlides() {
          if (!this.thumbs.length) return;
          this.slideObserver = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (!entry.isIntersecting) continue;
                const index = this.slides.indexOf(entry.target);
                this.thumbs.forEach((thumb, i) => {
                  thumb.classList.toggle('is-active', i === index);
                  thumb.toggleAttribute('aria-current', i === index);
                });
              }
            },
            { root: this.track, threshold: 0.6 }
          );
          this.slides.forEach((slide) => this.slideObserver.observe(slide));
        }

        watchStickyBar() {
          const bar = this.querySelector('[data-sticky]');
          const ctas = this.querySelector('[data-ctas]');
          if (!bar || !ctas) return;
          this.ctaObserver = new IntersectionObserver(([entry]) => {
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', show);
            bar.inert = !show;
          });
          this.ctaObserver.observe(ctas);
        }

        setupDescription() {
          const desc = this.querySelector('[data-desc]');
          const toggle = this.querySelector('[data-desc-toggle]');
          if (!desc || !toggle) return;
          if (desc.scrollHeight <= desc.clientHeight + 40) {
            desc.classList.add('is-open');
            return;
          }
          toggle.hidden = false;
          toggle.addEventListener('click', () => {
            const open = desc.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', open);
            toggle.querySelector('[data-more-label]').textContent = open ? 'Show less' : 'Read more';
            if (!open) this.querySelector('[data-details]').scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-redeem"] && !Shopify.designMode) return;
  try {
    
  class MfRedeem extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      if (!this.tabs.length) return;
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.show(tab.dataset.tab, true)));
      if (/^#(vip|madfutx|app)$/i.test(location.hash)) this.show('app', false);
    }

    show(path, push) {
      this.dataset.path = path;
      this.tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.tab === path)));
      if (push) history.replaceState(null, '', path === 'app' ? '#vip' : location.pathname + location.search);
    }
  }

  if (!customElements.get('mf-redeem')) customElements.define('mf-redeem', MfRedeem);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-squad"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-squad')) {
    customElements.define(
      'mf-squad',
      class extends HTMLElement {
        connectedCallback() {
          this.min = Number(this.dataset.min) || 3;
          this.percent = Number(this.dataset.percent) || 0;
          this.money = new Intl.NumberFormat(this.dataset.locale || undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'GBP',
            currencyDisplay: 'narrowSymbol',
          });
          this.slots = [...this.querySelectorAll('[data-slot]')];
          this.picks = [...this.querySelectorAll('[data-pick]')];
          this.squad = [];
          this.noteText = this.querySelector('[data-note]').textContent;

          this.picks.forEach((pick) => pick.addEventListener('click', () => this.toggle(pick)));
          this.slots.forEach((slot, i) =>
            slot.querySelector('button').addEventListener('click', () => {
              if (this.squad[i]) this.toggle(this.squad[i]);
              else this.querySelector('[data-pick][aria-pressed="false"]')?.focus();
            })
          );
          this.querySelector('[data-submit]').addEventListener('click', () => this.submit());
          this.render();
        }

        toggle(pick) {
          const index = this.squad.indexOf(pick);
          if (index > -1) {
            this.squad.splice(index, 1);
          } else if (this.squad.length < this.slots.length) {
            this.squad.push(pick);
          } else {
            this.flash('Squad full: tap a card on the pitch to swap it out.');
            return;
          }
          this.render();
        }

        render() {
          this.slots.forEach((slot, i) => {
            const pick = this.squad[i];
            const holder = slot.querySelector('[data-card]');
            const filled = Boolean(pick);
            const wasFilled = slot.classList.contains('is-filled');
            if (holder.dataset.variant !== (pick?.dataset.variant || '')) {
              holder.replaceChildren(...(pick ? [pick.querySelector('.mf-card27').cloneNode(true)] : []));
              holder.dataset.variant = pick?.dataset.variant || '';
              if (filled && !wasFilled) slot.classList.add('is-new');
            }
            slot.classList.toggle('is-filled', filled);
            const position = slot.querySelector('.mf-squad__pos').textContent;
            slot.querySelector('button').setAttribute('aria-label', filled ? `${position}: ${pick.dataset.name}, tap to remove` : `${position}: empty`);
            setTimeout(() => slot.classList.remove('is-new'), 600);
          });
          this.picks.forEach((pick) => pick.setAttribute('aria-pressed', String(this.squad.includes(pick))));

          const count = this.squad.length;
          const complete = count >= this.min;
          const prices = this.squad.map((pick) => Number(pick.dataset.price));
          const full = prices.reduce((sum, p) => sum + p, 0);
          const total = complete ? prices.reduce((sum, p) => sum + Math.round((p * (100 - this.percent)) / 100), 0) : full;
          const chem = Math.min(count / this.min, 1);

          this.querySelector('[data-count]').textContent = `${Math.min(count, this.min)}/${this.min}`;
          this.querySelector('[data-req]').classList.toggle('is-met', complete);
          this.querySelector('[data-chem]').style.setProperty('--chem', chem);
          this.querySelector('[data-chem-label]').textContent = `${Math.round(chem * 100)}%`;
          this.classList.toggle('is-complete', complete);
          this.querySelector('[data-total]').textContent = this.money.format(total / 100);
          const was = this.querySelector('[data-was]');
          was.hidden = !complete;
          was.textContent = this.money.format(full / 100);

          const button = this.querySelector('[data-submit]');
          button.disabled = !complete;
          this.querySelector('[data-submit-label]').textContent = complete
            ? 'Complete squad'
            : count === 0
              ? `Pick ${this.min} items`
              : `Add ${this.min - count} more`;
        }

        flash(message) {
          const note = this.querySelector('[data-note]');
          note.textContent = message;
          clearTimeout(this.noteTimer);
          this.noteTimer = setTimeout(() => (note.textContent = this.noteText), 3000);
        }

        async submit() {
          const button = this.querySelector('[data-submit]');
          const label = this.querySelector('[data-submit-label]');
          button.disabled = true;
          label.textContent = 'Building your squad…';
          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: this.squad.map((pick) => ({ id: Number(pick.dataset.variant), quantity: 1 })) }),
            });
            if (!response.ok) throw new Error((await response.json()).description || 'Could not add to cart');
            window.location.href = '/checkout';
          } catch (error) {
            this.flash(error.message);
            this.render();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
